import { mediaMax } from "components/designV2/breakpoints";
import { Spacing } from "components/designV2/constants";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export const SwishPaymentDetails = styled.div`
  display: grid;
  gap: ${Spacing.xs}px ${Spacing.md}px;
  grid-template-columns: minmax(0, 1fr) minmax(140px, auto);

  ${mediaMax.mobile} {
    gap: ${Spacing.xs}px;
    grid-template-columns: 1fr;
  }
`;

export const SwishPaymentError = styled.div`
  ${TypographyV2.s1}
  color: ${ColorV2.NegativeRed};
  margin-top: ${Spacing.xs}px;
  text-align: left;
`;

export const SwishPaymentLabel = styled.div`
  ${TypographyV2.b2}
  align-items: center;
  color: ${ColorV2.Blue4};
  display: flex;
  min-height: 32px;
`;

export const SwishPaymentValue = styled.div`
  ${TypographyV2.b1}
  align-items: center;
  color: ${ColorV2.Blue1};
  display: flex;
  justify-content: flex-end;
  justify-self: end;
  min-height: 32px;
  text-align: right;

  ${mediaMax.mobile} {
    justify-content: flex-start;
    justify-self: start;
    margin-bottom: ${Spacing.sm}px;
    text-align: left;
  }
`;

export const SwishPaymentFooterContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.sm}px;
  width: 100%;
`;

export const SwishPaymentFooterActions = styled.div`
  align-items: center;
  display: flex;
  gap: ${Spacing.sm}px;
  justify-content: flex-end;

  ${mediaMax.mobile} {
    align-items: stretch;
    flex-direction: column;
  }
`;

export const SwishPaymentFooter = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
`;

export const SwishPaymentNote = styled.div`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
  text-align: left;
`;
